(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('replacews', replacews);

    /** @ngInject */
    function replacews() {
        return function(text) {

          if(!text) return;

          return text.replace(/ /g, "_");
        };
    }

})();
